import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

import { ApplicationModule, getStoreModule } from "@/store";

@Component
export class PageTitle extends Vue {
  pageName = "Default";

  get pageTitle(): string {
    if (!this.pageName) return "Vignette";
    else return this.pageName + " | Vignette";
  }

  mounted(): void {
    getStoreModule(ApplicationModule, this.$store).setPageName(this.pageName || "");
  }

  @Watch("pageName")
  private pageNameChanged(val: string): void {
    getStoreModule(ApplicationModule, this.$store).setPageName(val || "");
  }
}
